import React from "react";

import { makeStyles } from "@material-ui/core";

import Button from "@ds-developer/button";
import RadioButtons from "@ds-developer/radio-buttons";

import { SalutationButtonsProps } from "./types";

const useStyles = (error: boolean) =>
  makeStyles(theme => ({
    salutationButton: {
      maxWidth: "85px",
      margin: theme.spacing(1, 0),
      color: error ? theme.palette.error.main : "auto",
    },
    container: error
      ? {
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: theme.palette.error.main,
          borderRadius: 4,
          display: "flex",
          maxWidth: 350,
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
        }
      : {},
  }));

const SalutationButtons: React.FC<SalutationButtonsProps> = ({
  salutations,
  onChange = () => {},
  value,
  disabled = false,
  error,
}) => {
  const classes = useStyles(Boolean(error))();
  return (
    <div className={classes.container}>
      <RadioButtons fullWidth label="" onChange={onChange} value={value}>
        {salutations.map(salutationOption => (
          <Button
            className={classes.salutationButton}
            disabled={disabled && value !== salutationOption}
            key={salutationOption}
            value={salutationOption}
            data-test={`salutation-radio-button-${salutationOption.toLowerCase()}`}
          >
            {salutationOption}
          </Button>
        ))}
      </RadioButtons>
    </div>
  );
};

export default SalutationButtons;
